import axios from '../axios'
// 查询banner列表
export const getBannerList = (data) => {
  return axios({
    url: '/con/manage/banner/list',
    method: 'POST',
    data: data
  })
}
// 删除
export const postDeleteRow = (data) => {
  return axios({
    url: '/con/manage/banner/delete',
    method: 'POST',
    data: data
  })
}
// 添加banner
export const addBanner = (data) => {
  return axios({
    url: '/con/manage/banner/save',
    method: 'POST',
    data: data
  })
}

// 上架下架
export const postUpdateBanner = (data, url) => {
  return axios({
    url,
    method: 'POST',
    data: data
  })
}
// 编辑
export const postEditBanner = (data) => {
  return axios({
    url:'/con/manage/banner/update',
    method: 'POST',
    data: data
  })
}
// 查寻单条数量
export const getBannerDeletail = (data) => {
  return axios({
    url:'/con/manage/banner/get',
    method: 'POST',
    data: data
  })
}
// 查询上架的banner列表
export const getBshelves_list = () => {
  return axios({
    url:'/con/manage/banner/shelves_list',
    method: 'POST',
  })
}
// 保存移动后的数据
export const postMove_sort = (data) => {
  return axios({
    url:'/con/manage/banner/move_sort',
    method: 'POST',
    data
  })
}







// WEBPACK FOOTER //
// ./src/http/moudules/banner.js